export default function template(){
  const tempbox =  document.querySelectorAll('.site-template .tempbox__list dt')
  tempbox.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.target.classList.toggle('active')
    })
  })
}